function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export const appcues = {
  identify(userId, userEmail, userProperties) {
    var _window$Appcues;

    (_window$Appcues = window.Appcues) === null || _window$Appcues === void 0 ? void 0 : _window$Appcues.identify(userId, _objectSpread(_objectSpread({}, userProperties), {}, {
      email: userEmail
    }));
  },

  sendEventDeprecated(eventName, _eventData) {
    var _window$Appcues2;

    (_window$Appcues2 = window.Appcues) === null || _window$Appcues2 === void 0 ? void 0 : _window$Appcues2.track(eventName);
  },

  report(eventType, eventName) {
    var _window$Appcues3;

    (_window$Appcues3 = window.Appcues) === null || _window$Appcues3 === void 0 ? void 0 : _window$Appcues3.track(getEventNameWithProperties(eventType, eventName));
  },

  sendPageView(_url, _eventData) {
    var _window$Appcues4;

    (_window$Appcues4 = window.Appcues) === null || _window$Appcues4 === void 0 ? void 0 : _window$Appcues4.page();
  }

};

const getEventNameWithProperties = (eventType, eventName) => "".concat(eventType, "-").concat(eventName);